import { Button as MuiButton } from '@mui/material';

// Wrapper component: the dashed "Upload document" CTA, used wherever
// documents can be attached (action detail, call summary, create action) so
// the affordance always looks the same.
const UploadDocumentButton = ({ onClick }: { onClick?: () => void }) => (
  <MuiButton
    fullWidth
    variant='outlined'
    color='primary'
    className='dashed'
    sx={{ py: 1.5 }}
    onClick={onClick}
  >
    Upload document
  </MuiButton>
);

export default UploadDocumentButton;
